import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { AppDispatch } from "../../store/store";
import { setUser, clearUser } from "../../store/slices/authSlice";
import { apiSlice } from "../../store/slices/apiSlice";
import { useToast } from "./use-toast";

export const useAuthAPI = () => {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const { showError, toastRef } = useToast();

  const handleLogin = async (
    email: string,
    password: string
  ): Promise<boolean> => {
    try {
      await dispatch(
        apiSlice.endpoints.login.initiate({ email, password })
      ).unwrap();
      const me = await dispatch(apiSlice.endpoints.getMe.initiate()).unwrap();
      dispatch(setUser(me));
      return true;
    } catch {
      showError("Ошибка", "Неверный логин или пароль");
      return false;
    }
  };

  const handleLogout = async (): Promise<boolean> => {
    try {
      await dispatch(apiSlice.endpoints.logout.initiate()).unwrap();
      dispatch(clearUser());
      navigate("/login");
      return true;
    } catch {
      showError("Ошибка", "Не удалось выйти");
      return false;
    }
  };

  return { handleLogin, handleLogout, toastRef };
};
